@let employeeStatus = employee().status.value;
@switch (employeeStatus) {
  @case (EmployeeStatus.UNAVAILABLE) {
    <div class="status">
      <div class="dot">
        <onyx-dot [color]="employee().status.color"></onyx-dot>
      </div>
      @if (employee().unavailability; as unavailability) {
        @let from = unavailability.dateRange.from!;
        @let to = unavailability.dateRange.to!;
        @if (!displayStatus()) {
          <div class="text">
            <span>
              {{
                `${DictionaryCode.EMPLOYEE_UNAVAILABILITY_REASON}.${unavailability.reason}`
                  | translate
              }}
            </span>

            <span class="reason f-body-s">
              {{ from | onyxDate: 'date-dot' : { endDate: to } }}
            </span>
          </div>
        } @else {
          <div class="display-status f-body-m f-medium">
            <span>
              {{
                `${DictionaryCode.EMPLOYEE_STATUS}.${employeeStatus}`
                  | translate
              }}
            </span>

            <span class="reason">
              <span>
                {{
                  `${DictionaryCode.EMPLOYEE_UNAVAILABILITY_REASON}.${unavailability.reason}`
                    | translate
                }}
              </span>

              ({{ from | onyxDate: 'date-dot' : { endDate: to } }})
            </span>
          </div>
        }
      } @else {
        <span>
          {{
            `${DictionaryCode.EMPLOYEE_STATUS}.${employeeStatus}` | translate
          }}
        </span>
      }
    </div>
  }
  @case (EmployeeStatus.INVITED) {
    <div class="status">
      <div class="dot">
        <onyx-dot [color]="employee().status.color"></onyx-dot>
      </div>

      <div class="text">
        <span>
          {{
            `${DictionaryCode.EMPLOYEE_STATUS}.${employeeStatus}` | translate
          }}
        </span>

        <div class="links">
          @if (hasAdd()) {
            <onyx-link
              color="blue"
              font="f-body-s"
              [disabled]="resendInviteLoading()"
              (click)="resendInvite$.next()"
            >
              {{ 'labels.sendAgain' | translate }}
            </onyx-link>
          }

          @if (hasCopyInviteLink()) {
            <span>·</span>

            <onyx-link
              color="blue"
              font="f-body-s"
              [disabled]="copyInviteLoading()"
              (click)="copyInviteLink$.next()"
            >
              {{ 'labels.copyLink' | translate }}
            </onyx-link>
          }
        </div>
      </div>
    </div>
  }
  @default {
    <div class="status">
      <div class="dot">
        <onyx-dot [color]="employee().status.color"></onyx-dot>
      </div>

      <span>
        {{ `${DictionaryCode.EMPLOYEE_STATUS}.${employeeStatus}` | translate }}
      </span>
    </div>
  }
}
